import { render, staticRenderFns } from "./InformacionAdicional.vue?vue&type=template&id=10ee9cf0&scoped=true"
import script from "./InformacionAdicional.vue?vue&type=script&lang=js"
export * from "./InformacionAdicional.vue?vue&type=script&lang=js"
import style0 from "./InformacionAdicional.vue?vue&type=style&index=0&id=10ee9cf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ee9cf0",
  null
  
)

export default component.exports